import { useMutation, useQuery } from '@tanstack/react-query';

import { UserPermission } from 'types/avp_permissions/permission';

import { axios } from '../axios';
import { ExtractFnReturnType, QueryConfig } from '../queryConfig';

interface Props {
  projectId: string;
  serviceName?: string;
  assetClass?: string;
  assetTemplateId?: string;
  partialActionNames?: string[];
}

export const getUserPermissionAllAction = ({
  projectId,
  serviceName,
  assetClass,
  assetTemplateId,
  partialActionNames,
}: Props): Promise<UserPermission> => {
  return axios
    .get(`oe/permissions/project/${projectId}/user-policy/all-resource-actions`, {
      params: {
        service_name: serviceName,
        asset_class_slug: assetClass,
        asset_template_id: assetTemplateId,
        partial_action_names: partialActionNames,
      },
    })
    .then((res) => res.data);
};

type QueryFnType = typeof getUserPermissionAllAction;
interface IGetUserPermissionAllAction extends Props {
  config?: QueryConfig<QueryFnType>;
}

export const useGetUserPermissionQuery = ({
  projectId,
  serviceName,
  assetTemplateId,
  partialActionNames,
  config,
}: IGetUserPermissionAllAction) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['getUserPermissionQuery', projectId, serviceName, assetTemplateId, partialActionNames],
    queryFn: () => getUserPermissionAllAction({ projectId, serviceName, assetTemplateId, partialActionNames }),
    enabled: !!projectId,
    ...config,
  });
};

export const useGetUserPermissionMutation = () => {
  return useMutation<ExtractFnReturnType<QueryFnType>, Error, Props>({
    mutationKey: ['getUserPermissionMutation'],
    mutationFn: (data) => getUserPermissionAllAction(data),
  });
};
